import React, { Component } from "react";
import { v4 as uuid } from 'uuid';
import AdmissionApi from "../../../../Services/AdmissionApi";
import Toggle from 'material-ui/Toggle';
import IconButton from 'material-ui/IconButton'
import {
  InformationCircleIcon,
  XCircleIcon,
  UploadIcon,
  TrashIcon
} from '@heroicons/react/outline'
import moment from "moment";
import { confirmAlert } from 'react-confirm-alert';
import { toast } from "react-toastify";
import Select from "react-select";

class UniversityMasterForm extends Component {
  admissionsService = new AdmissionApi()
  state = {
    id: null,
    allCategories: [],
    universityName: "",
    address: "",
    contactPerson: "",
    email: "",
    mobile: "",
    currentAds: [],
    ads: [],
    imgUrl: "",
    errors: {
      universityName: '',
      address: '',
      contactPerson: '',
      email: '',
      mobile: '',
      ads: {},
      currentAds: {}
    },
  }

  componentDidMount() {

    this.getAllCategories()
  }

  cbCourseCategories = (newResponse) => {
    if (newResponse.data.success) {
      const _categories = newResponse.data._embedded.category

      const allCategories = _categories.map(item => ({
        label: item.name,
        value: item.id,
      }))

      this.setState({ allCategories }, () => {
        const { data } = this.props
        if (data) {
          const { advertisement } = data
          const currentAds = advertisement.map(item => ({
            ...item,
            category: item.advertisementCategory.map(i => ({
              label: allCategories.find(j => j.value == i.categoryId).label,
              value: i.categoryId
            }))
          }))
    
          this.setState({
            id: data.id,
            universityName: data.name,
            address: data.address,
            contactPerson: data.contactPerson,
            email: data.email,
            mobile: data.mobile,
            currentAds
          })
        }

      });
    }
  }

  getAllCategories = () => {
    this.admissionsService.GetData(
      this.cbCourseCategories,
      "v1/students/alert/category"
    )
  }

  handleNewAdsValidation = () => {
    let { ads } = this.state
    let formIsValid = true
    let errors = {}

    ads.forEach((item) => {
      errors[item.id] = {}
      if (!item.img) {
        formIsValid = false
        errors[item.id].img = 'Cannot be empty'
      }

      if (!item.liveUntil) {
        formIsValid = false
        errors[item.id].liveUntil = 'Cannot be empty'
      }

      if (!item.link) {
        formIsValid = false
        errors[item.id].link = 'Cannot be empty'
      }

      if (!item.category.length) {
        formIsValid = false
        errors[item.id].category = 'Cannot be empty'
      }
    })

    this.setState(state => ({
      errors: {
        ...state.errors,
        ads: {
          ...state.errors.ads,
          ...errors
        }
      }
    }))
    return formIsValid;
  }

  handleUniValidation = () => {
    let fields = this.state
    let formIsValid = true
    let errors = {
      universityName: '',
      address: '',
      contactPerson: '',
      email: '',
      mobile: '',
    }

    //name
    if (!fields["universityName"]) {
      formIsValid = false;
      errors["universityName"] = "Cannot be empty";
    }

    //address
    if (!fields["address"]) {
      formIsValid = false;
      errors["address"] = "Cannot be empty";
    }

    // contactPerson
    if (!fields["contactPerson"]) {
      formIsValid = false;
      errors["contactPerson"] = "Cannot be empty";
    }

    if (fields["contactPerson"] && /[^A-Za-z \.]/.test(fields['contactPerson'])) {
      formIsValid = false;
      errors["contactPerson"] = "Special characters and numbers are not allowed";
    }

    // email
    if (!fields["email"]) {
      formIsValid = false;
      errors["email"] = "Cannot be empty";
    }

    if (fields['email'] && !fields["email"].match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
      formIsValid = false;
      errors["email"] = "Email is not valid";
    }

    if (!fields["mobile"]) {
      formIsValid = false;
      errors["mobile"] = "Cannot be empty";
    }

    if (fields["mobile"] && !fields["mobile"].match(/^\d{10}$/)) {
      formIsValid = false;
      errors["mobile"] = "Mobile is not valid"
    }

    this.setState(state => ({
      errors: {
        ...state.errors,
        ...errors
      }
    }))
    return formIsValid;
  }

  handleCurrentAdsValidation = (id) => {
    const { currentAds } = this.state
    const ad = currentAds.find(i => i.id === id)

    let formIsValid = true
    let errors = {}

    if (!ad.liveUntil || ad.liveUntil === '0000-00-00') {
      formIsValid = false
      errors.liveUntil = 'Cannot be empty'
    }

    if (!ad.url) {
      formIsValid = false
      errors.link = 'Cannot be empty'
    }

    if (!ad.category.length) {
      formIsValid = false
      errors.category = 'Cannot be empty'
    }

    this.setState(state => ({
      errors: {
        ...state.errors,
        currentAds: {
          ...state.errors.currentAds,
          [id]: errors
        }
      }
    }))
    return formIsValid
  }

  uploadImage = (img) => {
    const payload = new FormData()
    payload.append('file', img)
    payload.append('title', 'Advertisement')
    payload.append('description', 'University ad')
    payload.append('path', 'v1/advertisement/images')

    return this.admissionsService.uploadMedia("v1/media/images", payload)
      .then(res => `https://media.notifyi.in/${res.attributes.url}`)
  }

  handleFileChange = (file, adId) => {
    if(!file) {
      this.setState((prevState) => ({
        ads: prevState.ads.map((item) => {
          return item.id === adId
            ? {
              ...item,
              img: null
            }
            : item
        }),
        currentAds: prevState.currentAds.map((item) => {
          return item.id === adId
            ? {
              ...item,
              img: null
            }
            : item
        })
      }))
      return
    }

    this.uploadImage(file)
      .then(url => {
        this.setState((prevState) => ({
          ads: prevState.ads.map((item) => {
            return item.id === adId
              ? {
                ...item,
                img: url
              }
              : item
          }),
          currentAds: prevState.currentAds.map((item) => {
            return item.id === adId
              ? {
                ...item,
                img: url
              }
              : item
          }),
          errors: {
            ...prevState.errors,
            ads: {
              ...prevState.errors.ads,
              [adId]: {
                ...prevState.errors.ads[adId],
                img: ''
              }
            }
          }
        }))
      })
      .catch(err => {
        this.setState({ imgUrl: null })
      })
  }

  createUniversity = () => {
    if (!this.handleUniValidation()) return

    const {
      universityName,
      address,
      contactPerson,
      email,
      mobile,
      ads
    } = this.state

    const formData = new FormData()

    formData.append('name', universityName)
    formData.append('address', address)
    formData.append('contactPerson', contactPerson)
    formData.append('email', email)
    formData.append('mobile', mobile)
    formData.append('status', 1)


    this.admissionsService.createNew(
      (res) => {
        if (ads.length) {
          this.adsSubmission(res.data.attributes.id)
        } else {
          if(res.status === 200) toast.success(("University added successfully."))
        }
        this.setState({ id: res.data.attributes.id })
      },
      formData,
      "v1/university/create"
    )
  }

  updateUniversity = () => {
    if (!this.handleUniValidation()) return

    const {
      id,
      universityName,
      address,
      contactPerson,
      email,
      mobile
    } = this.state

    const formData = new FormData()

    formData.append('id', id)
    formData.append('name', universityName)
    formData.append('address', address)
    formData.append('contactPerson', contactPerson)
    formData.append('email', email)
    formData.append('mobile', mobile)
    formData.append('status', 1)


    this.admissionsService.createNew(
      (res) => {
        if(res.status === 200) {
          toast.success("University updated successfully!")
        }
      },
      formData,
      "v1/university/update"
    )
  }

  adsSubmission = (id = null) => {
    if (!this.handleNewAdsValidation()) return
    const { ads } = this.state

    const formData = new FormData()

    formData.append('universityId', id)
    ads.forEach(item => formData.append('images[]', item.img))
    ads.forEach(item => formData.append('advertisements[]', JSON.stringify({
      url: item.link,
      liveUntil: item.liveUntil,
      status: item.status ? 1 : 0,
      categoryIds: item.category.map(i => ({
        id: i.value,
        status: 1
      }))
    })))

    this.admissionsService.createNew(
      (res) => {
        const { allCategories } = this.state
        if(res.status === 200) toast.success(("Advertisement(s) added successfully."))
        const newAds = res.data.attributes.map(item => ({
          ...item,
          category: item.advertisementCategory.map(i => ({
            label: allCategories.find(j => j.value == i.categoryId).label,
            value: i.categoryId
          }))
        }))

        this.setState(state => ({
          currentAds: [
            ...state.currentAds,
            ...newAds
          ],
          ads: []
        }))
      },
      formData,
      "v1/advertisement/create"
    )
  }

  resetErrorMsg = (errorId, isAd) => {
    if (isAd) {
      this.setState((preState) => ({
        errors: {
          ...preState.errors,
          ads: {
            ...preState.errors.ads,
            [errorId]: {
              ...preState.errors.ads[errorId],
              [isAd]: ''
            }
          },
          currentAds: {
            ...preState.errors.currentAds,
            [errorId]: {
              ...preState.errors.currentAds[errorId],
              [isAd.slice(5).toLowerCase()]: ''
            }
          }
        }
      }))
    } else {
      this.setState((preState) => ({
        errors: { ...preState.errors, [errorId]: "" },
      }))
    }
  }

  handleFormFieldChange = (e, isToggled = false) => {
    e.preventDefault()
    const { value, id, name } = e.target

    switch (name) {
      case 'status':
        this.setState((prevState) => ({
          ads: prevState.ads.map((item) => {
            return item.id === id
              ? {
                ...item,
                status: isToggled
              }
              : item
          })
        }))
        break;
      case 'curAdStatus':
        this.setState((prevState) => ({
          currentAds: prevState.currentAds.map((item) => {
            return item.id == id
              ? {
                ...item,
                status: isToggled
              }
              : item
          })
        }))
        break;
      case 'liveUntil':
        this.setState((prevState) => ({
          ads: prevState.ads.map((item) => {
            return item.id === id
              ? {
                ...item,
                liveUntil: value
              }
              : item
          })
        }))
        break;
      case 'curAdLiveUntil':
        this.setState((prevState) => ({
          currentAds: prevState.currentAds.map((item) => {
            return item.id == id
              ? {
                ...item,
                liveUntil: value
              }
              : item
          })
        }))
        break;
      case 'link':
        this.setState((prevState) => ({
          ads: prevState.ads.map((item) => {
            return item.id === id
              ? {
                ...item,
                link: value
              }
              : item
          })
        }))
        break;
      case 'curAdLink':
        this.setState((prevState) => ({
          currentAds: prevState.currentAds.map((item) => {
            return item.id == id
              ? {
                ...item,
                url: value
              }
              : item
          })
        }))
        break;
      default:
        this.setState({
          [id]: value
        })
    }

    this.resetErrorMsg(id, name)

  }

  addAdvertisement = () => {
    this.setState((prevState) => ({
      ads: [
        ...prevState.ads,
        {
          id: uuid(),
          img: '',
          link: '',
          category: '',
          liveUntil: moment().format('YYYY-MM-DD'),
          status: true
        }
      ]
    }))
  }

  removeAdvertisement = (id) => {
    this.setState((prevState) => ({
      ads: prevState.ads.filter(item => item.id !== id)
    }))
  }

  deleteItem = (item) => {
    const { currentAds } = this.state
    confirmAlert({
      title: 'Confirm ?',
      message: 'Are You Sure you want to delete ?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.admissionsService.deleteAd(
              (res) => {
                if(res.status === 200) {
                  toast.success(("Advertisement deleted successfully."))
                  const data = currentAds.filter(ad => ad.id !== item.id)
                  this.setState({ currentAds: data })
                }
              },
              `v1/advertisement/delete`,
              item.id
            )
          }
        },
        {
          label: 'No',
          onClick: () => { }
        }
      ]
    })
  }

  updateAd = (item) => {
    if (!this.handleCurrentAdsValidation(item.id)) return
    const formData = new FormData()

    formData.append('id', item.id)
    formData.append('universityId', item.universityId)
    formData.append('url', item.url)
    formData.append('liveUntil', item.liveUntil)
    item.category.forEach(i => formData.append('categoryIds[]', i.value))
    formData.append('status', item.status ? '1' : '0')
    if (item.img) formData.append('image', item.img)


    this.admissionsService.createNew(
      (res) => {
        if(res.status === 200) {
          toast.success("Advertisement updated successfully!")
        }
      },
      formData,
      "v1/advertisement/update"
    )
  }

  handleCategoriesChange = (value, id, name) => {
    switch(name) {
      case 'category':
        this.setState((prevState) => ({
          ads: prevState.ads.map((item) => {
            return item.id === id
              ? {
                ...item,
                category: value
              }
              : item
          })
        }))
        break;
      case 'curAdCategory':
        this.setState((prevState) => ({
          currentAds: prevState.currentAds.map((item) => {
            return item.id == id
              ? {
                ...item,
                category: value
              }
              : item
          })
        }))
        break;
      default:
        break;
    }

    this.resetErrorMsg(id, name)
  }

  render() {
    const {
      id,
      allCategories,
      universityName,
      address,
      contactPerson,
      email,
      mobile,
      ads,
      currentAds,
      errors
    } = this.state

    return (
      <div className="row">
        <div className="col-sm-12 col-lg-6">
          <div className={`form-group ${errors["universityName"] && 'm-0'}`}>
            <label>University / Institute</label>
            <input
              type="text"
              id="universityName"
              className="form-control alert-filter__input"
              placeholder="University / Institute"
              value={universityName}
              onChange={this.handleFormFieldChange}
            />
          </div>
          <span style={{ color: "red", fontFamily: "italian" }}>
            {errors["universityName"]}
          </span>
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className={`form-group ${errors["contactPerson"] && 'm-0'}`}>
            <label>Contact Person</label>
            <input
              type="text"
              id="contactPerson"
              className="form-control alert-filter__input"
              placeholder="Contact Person"
              value={contactPerson}
              onChange={this.handleFormFieldChange}
            />
          </div>
          <span style={{ color: "red", fontFamily: "italian" }}>
            {errors["contactPerson"]}
          </span>
        </div>
        <div className="col-sm-12">
          <div className={`form-group ${errors["address"] && 'm-0'}`}>
            <label>Address</label>
            <textarea
              id="address"
              className="form-control alert-filter__input"
              placeholder="Address"
              value={address}
              onChange={this.handleFormFieldChange}
            />
          </div>
          <span style={{ color: "red", fontFamily: "italian" }}>
            {errors["address"]}
          </span>
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className={`form-group ${errors["email"] && 'm-0'}`}>
            <label>Email</label>
            <input
              type="text"
              id="email"
              className="form-control alert-filter__input"
              placeholder="Email"
              value={email}
              onChange={this.handleFormFieldChange}
            />
          </div>
          <span style={{ color: "red", fontFamily: "italian" }}>
            {errors["email"]}
          </span>
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className={`form-group ${errors["mobile"] && 'm-0'}`}>
            <label>Mobile Number</label>
            <input
              type="text"
              id="mobile"
              className="form-control alert-filter__input"
              placeholder="Mobile Number"
              value={mobile}
              onChange={this.handleFormFieldChange}
            />
          </div>
          <span style={{ color: "red", fontFamily: "italian" }}>
            {errors["mobile"]}
          </span>
        </div>
        {id && (
          <div className="col-12 text-right my-3">
            <button
              onClick={this.updateUniversity}
              className="btn btn--primary ml-2"
            >
              Update
            </button>
          </div>
        )}
        <div className="col-12">
          <hr />
        </div>
        <div className="col-12">
          {currentAds.map((item, i) => (
            <div className="row" key={item.id}>
              <div className="col-12 d-flex justify-content-between">
                <div className="d-flex align-items-center">
                  <h4 className="font-bold text-nowrap">Advertisement {i + 1}</h4>
                  <Toggle
                    checked={!!item.status}
                    trackSwitchedStyle={{ background: '#8bc779' }}
                    thumbSwitchedStyle={{ background: '#49AA2B' }}
                    onToggle={this.handleFormFieldChange}
                    id={item.id}
                    name="curAdStatus"
                  />
                  <span className="ml-2">{item.status ? 'Active' : 'Inactive'}</span>
                </div>
                <span>
                  <IconButton title='Update' onClick={() => this.updateAd(item)}>
                    <UploadIcon className='text-secondary' />
                  </IconButton>
                  <IconButton title='Delete' onClick={() => this.deleteItem(item)}>
                    <TrashIcon className='text-danger' />
                  </IconButton>
                </span>
              </div>
              <div className="col-sm-12 col-lg-6">
                <div className="form-group">
                  <label>Image</label>
                  <div>
                    <input onChange={({ target: { files } }) => this.handleFileChange(files[0], item.id)} type="file" />
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-lg-6">
                <div className={`form-group ${errors.currentAds[item.id] ? errors.currentAds[item.id].liveUntil && 'm-0' : null}`}>
                  <label>Live Until</label>
                  <input
                    type="date"
                    className="form-control alert-filter__input"
                    name="curAdLiveUntil"
                    id={item.id}
                    value={item.liveUntil}
                    onChange={this.handleFormFieldChange}
                  />
                </div>
                <span style={{ color: "red", fontFamily: "italian" }}>
                  {errors.currentAds[item.id] ? errors.currentAds[item.id].liveUntil : null}
                </span>
              </div>
              <div className="col-sm-12">
                <div className={`form-group ${errors.currentAds[item.id] ? errors.currentAds[item.id].link && 'm-0' : null}`}>
                  <label>
                    URL
                    <IconButton className="info-icon" title="URL on which student will be redirected">
                      <InformationCircleIcon className='w-16 text-secondary' />
                    </IconButton>
                  </label>
                  <input
                    type="text"
                    className="form-control alert-filter__input"
                    name="curAdLink"
                    id={item.id}
                    value={item.url}
                    onChange={this.handleFormFieldChange}
                    placeholder="URL"
                  />
                </div>
                <span style={{ color: "red", fontFamily: "italian" }}>
                  {errors.currentAds[item.id] ? errors.currentAds[item.id].link : null}
                </span>
              </div>
              <div className="col-sm-12">
                <div className={`form-group ${errors.currentAds[item.id] ? errors.currentAds[item.id].category && 'm-0' : null}`}>
                  <label>Category</label>
                  <Select
                    style={{ width: "100%;" }}
                    isMulti={true}
                    value={item.category}
                    onChange={(category) => this.handleCategoriesChange(category, item.id, 'curAdCategory')}
                    options={allCategories}
                    placeholder='Select relevant course categories*'
                  />
                </div>
                <span style={{ color: "red", fontFamily: "italian" }}>
                  {errors.currentAds[item.id] ? errors.currentAds[item.id].category : null}
                </span>
              </div>
            </div>
          ))}
        </div>
        <div className="col-12">
          {ads.map((item, i) => (
            <div className="row" key={item.id}>
              <div className="col-12 d-flex justify-content-between">
                <div className="d-flex align-items-center">
                  <h4 className="font-bold text-nowrap">Advertisement {currentAds.length + i + 1}</h4>
                  <Toggle
                    checked={item.status}
                    trackSwitchedStyle={{ background: '#8bc779' }}
                    thumbSwitchedStyle={{ background: '#49AA2B' }}
                    onToggle={this.handleFormFieldChange}
                    id={item.id}
                    name="status"
                  />
                  <span className="ml-2">{item.status ? 'Active' : 'Inactive'}</span>
                </div>
                <IconButton onClick={() => this.removeAdvertisement(item.id)}>
                  <XCircleIcon className='text-danger' />
                </IconButton>
              </div>
              <div className="col-sm-12 col-lg-6">
                <div className={`form-group ${errors.ads[item.id] ? errors.ads[item.id].img && 'm-0' : null}`}>
                  <label>Image</label>
                  <div>
                    <input onChange={({ target: { files } }) => this.handleFileChange(files[0], item.id)} type="file" />
                  </div>
                </div>
                <span style={{ color: "red", fontFamily: "italian" }}>
                  {errors.ads[item.id] ? errors.ads[item.id].img : null}
                </span>
              </div>
              <div className="col-sm-12 col-lg-6">
                <div className={`form-group ${errors.ads[item.id] ? errors.ads[item.id].liveUntil && 'm-0' : null}`}>
                  <label>Live Until</label>
                  <input
                    type="date"
                    className="form-control alert-filter__input"
                    name="liveUntil"
                    id={item.id}
                    value={item.liveUntil}
                    onChange={this.handleFormFieldChange}
                  />
                </div>
                <span style={{ color: "red", fontFamily: "italian" }}>
                  {errors.ads[item.id] ? errors.ads[item.id].liveUntil : null}
                </span>
              </div>
              <div className="col-sm-12">
                <div className={`form-group ${errors.ads[item.id] ? errors.ads[item.id].link && 'm-0' : null}`}>
                  <label>
                    URL
                    <IconButton className="info-icon" title="URL on which student will be redirected">
                      <InformationCircleIcon className='w-16 text-secondary' />
                    </IconButton>
                  </label>
                  <input
                    type="text"
                    className="form-control alert-filter__input"
                    name="link"
                    id={item.id}
                    value={item.link}
                    onChange={this.handleFormFieldChange}
                    placeholder="URL"
                  />
                </div>
                <span style={{ color: "red", fontFamily: "italian" }}>
                  {errors.ads[item.id] ? errors.ads[item.id].link : null}
                </span>
              </div>
              <div className="col-sm-12">
                <div className={`form-group ${errors.ads[item.id] ? errors.ads[item.id].category && 'm-0' : null}`}>
                  <label>Category</label>
                  <Select
                    style={{ width: "100%;" }}
                    isMulti={true}
                    value={item.category}
                    onChange={(category) => this.handleCategoriesChange(category, item.id, 'category')}
                    options={allCategories}
                    placeholder='Select relevant course categories*'
                  />
                </div>
                <span style={{ color: "red", fontFamily: "italian" }}>
                  {errors.ads[item.id] ? errors.ads[item.id].category : null}
                </span>
              </div>
            </div>
          ))}
          <div className="row">
            <div className="col-sm-12">
              <button className="btn btn-link w-100 text-center" onClick={this.addAdvertisement}>+ Add Advertisement</button>
            </div>
          </div>
        </div>
        {ads.length || !id ? (
          <div className="col-12 text-right my-3">
            {/* <button
              onClick={() => updateRoutePage('university')}
              className="btn btn-link"
            >
              Cancel
            </button> */}
            <button
              onClick={id ? () => this.adsSubmission(id) : this.createUniversity}
              className="btn btn--primary ml-2"
            >
              Submit
            </button>
          </div>
        ) : null}
      </div>
    )
  }
}

export default UniversityMasterForm



/** WEBPACK FOOTER **
 ** ./src/components/Admin/UniversityMaster/UniversityMasterForm/index.js
 **/